import { EditProps } from './interactive-response-categorise.constants';
import { SubActivityEdit } from '../../sub-activity/sub-activity-edit';
import InteractiveResponseCategorisePlayPreview from './play/interactive-response-categorise-play-preview';
import * as Styled from '../interactive-response.style';
import ComponentAltTextButton from '../../shared/component-alt-text/component-alt-text-button';
import { ComponentActions } from '../../components.style';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { getComponentSelectorId } from '../../shared/logic/get-component-selector-id';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';

const InteractiveResponseCategoriseEdit = (props: EditProps) => {
  const {
    id,
    sectionId,
    type,
    sort,
    subActivityProperties,
    properties,
    version,
  } = props;
  const { openDrawer } = useActivityBuilderContext();

  return (
    <SubActivityEdit
      id={id}
      component={{
        language: LANGUAGE_CODE_EN_AU,
        id,
        type,
        sort,
        properties,
        sectionId,
        version,
        __typename: 'ActivitiesCategoriseResponseComponent',
      }}
      subActivityDetails={subActivityProperties}
    >
      {container => (
        <Styled.InteractiveResponseContainer
          id={getComponentSelectorId(props.id)}
          data-selector="interactive-response-container"
        >
          <InteractiveResponseCategorisePlayPreview
            {...props}
            instructionHeight={container?.offsetHeight || 0}
            shouldShuffle={false}
          />
          {properties.interactiveResponseCategorise.items.length > 0 && (
            <ComponentActions>
              <ComponentAltTextButton
                hasAltText={
                  !!properties.interactiveResponseCategorise.items.every(
                    item => item.image?.description
                  )
                }
                onClick={() => openDrawer({ componentId: id })}
              />
            </ComponentActions>
          )}
        </Styled.InteractiveResponseContainer>
      )}
    </SubActivityEdit>
  );
};

export default InteractiveResponseCategoriseEdit;
